import { memo } from 'react';

import withComponentName from '../../../../../decorators/withComponentName';

import CustomCarousel from '../../../../CustomCarousel';

import setAmount from '../../../../../helpers/setAmount';

import members from '../imagesMember';

import Styles from '../styles.module.scss';

export const MembersOfSection = ({ windowWidth }) => (
  <div className={Styles.member_of}>
    <h3 className={`${Styles.title} text-uppercase`}>Member of / alum of</h3>
    {windowWidth <= 767 ? (
      <div className={Styles.carousel_container}>
        <CustomCarousel
          width={windowWidth}
          amountInSlide={setAmount(windowWidth, 6, 3, 1)}
          section="logos"
          category="members"
          data={members}
        />
      </div>
    ) : (
      <div className={Styles['homepage-logos']}>
        {members.map(({
          logo,
          id,
          width,
          height,
        }) => (
          <div className={Styles.logo} key={id}>
            <img
              width={width}
              height={height}
              src={logo}
              alt=""
            />
          </div>
        ))}
      </div>
    )}
  </div>
);

export default withComponentName(memo(MembersOfSection));
